"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AppMain", {
  enumerable: true,
  get: function () {
    return _AppMain.default;
  }
});
Object.defineProperty(exports, "Navbar", {
  enumerable: true,
  get: function () {
    return _index.default;
  }
});
Object.defineProperty(exports, "Settings", {
  enumerable: true,
  get: function () {
    return _index2.default;
  }
});
Object.defineProperty(exports, "Sidebar", {
  enumerable: true,
  get: function () {
    return _index3.default;
  }
});
Object.defineProperty(exports, "TagsView", {
  enumerable: true,
  get: function () {
    return _index4.default;
  }
});
var _AppMain = _interopRequireDefault(require("./AppMain.vue"));
var _index = _interopRequireDefault(require("./Navbar/index.vue"));
var _index2 = _interopRequireDefault(require("./Settings/index.vue"));
var _index3 = _interopRequireDefault(require("./Sidebar/index.vue"));
var _index4 = _interopRequireDefault(require("./TagsView/index.vue"));